// 이미지를 미리 받아 브라우저 HTTP 캐시에 채워둔다.
// 실제 <img> 가 mount 될 때 네트워크를 타지 않아 pop-in 이 사라진다.
//
// <link rel="prefetch"> 대신 new Image() 를 쓰는 이유 — DOM 삽입·정리가 필요 없고
// 네이티브 WebView/Safari 에서 rel=prefetch 지원이 고르지 않다.

// 이미 요청한 URL 재요청 방지 (뒤로가기로 같은 스텝을 오가도 1회만 나간다)
const requested = new Set<string>();

export function prefetchImages(urls: string[]) {
  urls.forEach((url) => {
    if (!url || requested.has(url)) return;
    requested.add(url);
    const img = new Image();
    img.src = url;
  });
}

// 테스트 전용 — 모듈 스코프 캐시 초기화
export function __resetPrefetchCacheForTest() {
  requested.clear();
}
